module.exports = __webpack_public_path__ + "static/media/messages.55ad7491.png";